import { theme, Icon } from '@salecycle/ui-component-library';
import { LegacyCard } from 'components/experimental/Card/LegacyCard';
import { useTranslation } from 'react-i18next';

interface Props {
  heading: string;
  canSend: boolean;
  isLoading?: boolean;
}

export function ProductSendCard(props: Props) {
  const { t } = useTranslation('compliance');
  return (
    <LegacyCard variation="primary" heading={props.heading} isLoading={props.isLoading}>
      {props.canSend ? (
        <p style={{ color: theme.vars.newColor.green2, textAlign: 'center' }}>
          <Icon icon="check" color={theme.vars.newColor.green2} /> <b>{t('testSendRulesPage.canSend')}</b>
        </p>
      ) : (
        <p style={{ color: theme.vars.newColor.red2, textAlign: 'center' }}>
          <Icon icon="times" color={theme.vars.newColor.red2} /> <b>{t('testSendRulesPage.canNotSend')}</b>
        </p>
      )}
    </LegacyCard>
  );
}
